import { format, parseISO } from "date-fns";

export function getTimeFromSchedule(
  scheduleDateString: string,
  strFormat = "h:mm a"
): string {
  return format(parseISO(scheduleDateString.replace("Z", "")), strFormat);
}

export function getDateFromSchedule(
  scheduleDateString: string,
  strFormat = "yyyy-MM-dd"
): string {
  return format(parseISO(scheduleDateString.replace("Z", "")), strFormat);
}

export function getScheduleDateWithTime(scheduleDateString: string): string {
  return `${getDateFromSchedule(scheduleDateString)}T${getTimeFromSchedule(scheduleDateString, "HH:mm:ss")}`;
}
